import { Container } from "@mui/material";
export const Note = ({
  message,
  style,
}: {
  message: string;
  style?: React.CSSProperties;
}) => {
  return (
    <Container
      style={{
        // margin: 30,
        backgroundColor: "lightblue",
        width: "100%",
        maxWidth: 700,
        borderRadius: 14,
        minHeight: 0,
        padding: "16px 24px",
        boxSizing: "border-box",
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        // textAlign: "center",
        // alignSelf:'center',
        margin: "30px auto",
        ...style,
      }}
    >
      <p style={{ textAlign: "center" }}>{message}</p>
    </Container>
  );
};
